import { useIntl } from 'react-intl';

export const getFormattedTime = ({ date, tz, format = 'date' }) => {
  const newDate = new Date(date);
  const intl = useIntl();

  let options = { timeZone: tz };
  switch (format) {
    case 'date': // 'DD/MM/YYYY'
      options = {
        ...options,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      };
      break;
    case 'date_human': // 'dddd DD MMMM YYYY' -> 'giovedì 05 giugno 2025'
      options = {
        ...options,
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: '2-digit',
      };
      break;
    case 'datetime': // 'DD/MM/YYYY HH:mm'
      options = {
        ...options,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
      };
      break;
    case 'time': // 'HH:mm'
      options = {
        ...options,
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
      };
      break;
    case 'weekday':
      options = {
        ...options,
        weekday: 'long',
      };
    default:
      break;
  }
  const formatter = new Intl.DateTimeFormat(intl.locale, options);

  return formatter.format(newDate);
};
